import * as React from 'react';
import { FC, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ToolBar from './ToolBar';
// import WeeklyPacksPerGrossiste from './WeeklyPacksPerGrossiste';
import MonthlyPacksPerGrossiste from './MonthlyPacksPerGrossiste';
// import WeeklyQuantitiesPerGrossiste from './WeeklyQuantitiesPerGrossiste';
import MonthlyQuantitiesPerGrossiste from './MonthlyQuantitiesPerGrossiste';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '0em',
        // backgroundColor: 'red',
    },
    flex: { display: 'flex' },
    flexColumn: {
        display: 'flex',
        marginBottom: '0em',
        // backgroundColor: 'red',
    },
    leftCol: { flex: 1, marginRight: '0em' },
    rightCol: { flex: 1, marginLeft: '0em' },
    kpiContainer: { padding: '1em' },
    // singleCol: { marginTop: '0.5em', marginBottom: '0.5em' },
}));

// const Spacer = () => <span style={{ width: '1em' }} />;
// const VerticalSpacer = () => <span style={{ height: '1em' }} />;

const GrossisteDashboard: FC<any> = ({ lastyear = false }) => {
    const [grossiste, setGrossiste] = useState('all');

    const classes = useStyles();

    return (
        <div className={classes.container}>
            {/* <div className={classes.flexColumn}>
                <div className={classes.leftCol}>
                    <div className={classes.kpiContainer}>
                        <ToolBar setGrossiste={setGrossiste} />
                    </div>
                </div>
                <div className={classes.rightCol}></div>
            </div> */}
            <div className={classes.flexColumn}>
                {/* <div className={classes.leftCol}>
                    <div className={classes.kpiContainer}>
                        <WeeklyPacksPerGrossiste
                            grossiste={grossiste}
                            height={200}
                        />
                    </div>
                    <div className={classes.kpiContainer}>
                        <WeeklyQuantitiesPerGrossiste
                            grossiste={grossiste}
                            height={200}
                        />
                    </div>
                </div> */}
                <div className={classes.rightCol}>
                    {/* <div className={classes.kpiContainer}>
                        <MonthlyPacksPerGrossiste
                            grossiste={grossiste}
                            height={250}
                        />
                    </div> */}
                    <div className={classes.kpiContainer}>
                        <MonthlyQuantitiesPerGrossiste
                            grossiste={grossiste}
                            height={250}
                            lastyear={lastyear}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GrossisteDashboard;
